import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from './Button'
import Card from './Card'
import Cards from './Cards'
import PersonUi from './PersonUi'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { PersonLiteDto } from '../api/person/models/PersonDto'

type Props = {
    networkLinks: PersonLiteDto[]
    onRemove: (id: string) => void
}

function NetworkLinks({ networkLinks, onRemove }: Props): React.JSX.Element {
    const sortedNetworkLinks = [...networkLinks].sort((a, b) => {
        const fullNameA = `${a.firstName} ${a.lastName}`.toLowerCase()
        const fullNameB = `${b.firstName} ${b.lastName}`.toLowerCase()
        return fullNameA.localeCompare(fullNameB)
    })

    return (
        <div>
            <Cards className="rounded-lg mt-2" maxRows={2} rowHeight={140}>
                {sortedNetworkLinks.map((networkLink, index) => (
                    <Card
                        key={`person-${index}`}
                        showTopSection={false}
                        classes="truncate w-[250px] h-[130px] bg-white text-[12px] pl-2 pt-2 pr-2"
                    >
                        <div className="flex justify-between items-start">
                            <PersonUi
                                imageClasses="w-10 h-10"
                                nameFontSize="text-[14px]"
                                person={networkLink}
                                textSize="text-[12px]"
                            />
                            <Button
                                style="mild-danger"
                                type="button"
                                size="small"
                                onClick={() => onRemove(networkLink.id)}
                            >
                                <FontAwesomeIcon icon={faTrashCan} />
                            </Button>
                        </div>
                    </Card>
                ))}
            </Cards>
        </div>
    )
}

export default NetworkLinks
